import React, { useState, useEffect } from "react";

const NoLogin = () => {
  const [showMsg, setShowMsg] = useState(false);

  useEffect(() => {
    setTimeout(function() { 
      setShowMsg(true); }, 2000);
  }, []);

 return (
  <div className="container">
    <div className="row">
      <div className="col-md-12">
      {showMsg && (
          <h1 className="text-center" style={{marginTop:'200px', marginBottom:'200px'}}>
            Por favor inicie a sua sessão
          </h1>
        )}
      </div>
    </div>
  </div>
 );
};

export default NoLogin;
